import { GetterTree } from 'vuex'

import { RootState } from '../state'
import itemGroupsGetters from './itemGroups/getters'
import itemsGetters from './items/getters'
import optionGroupsGetters from './optionGroups/getters'
import optionsGetters from './options/getters'
import portionsGetters from './portions/getters'
import { MenuState } from './state'

const getters: GetterTree<MenuState, RootState> = {
  ...itemGroupsGetters,
  ...itemsGetters,
  ...optionGroupsGetters,
  ...optionsGetters,
  ...portionsGetters
}

export default getters
